<template>
  <div class="container">
    <form autocomplete="off" @submit.prevent="handleSubmit">
      <div class="row">
        <div class="separador"></div>
        <div class="separador"></div>
        <div
          class="form-group col-md-6"
          :class="{'has-error' : errors.has('name'), 'has-success' : fields.name && fields.name.valid }"
        >
          <float-label>
            <input
              type="text"
              name="name"
              id="name"
              class="form-control efecto"
              placeholder="Nombre"
              v-model="user.nombre"
              v-validate="'required|alpha_spaces|max:255'"
              data-vv-as="Nombre"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('name')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('name') }}</div>
        </div>
        <div
          class="form-group col-md-6"
          :class="{ 'has-error': errors.has('lastname'), 'has-success' : fields.lastname && fields.lastname.valid }"
        >
          <float-label>
            <input
              type="text"
              name="lastname"
              id="lastname"
              class="form-control efecto"
              placeholder="Apellido"
              v-model="user.apellido"
              v-validate="'required|alpha_spaces|max:255'"
              data-vv-as="Apellido"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('lastname')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('lastname') }}</div>
        </div>
      </div>
      <div class="row">
        <div
          class="form-group col-md-6"
          :class="{ 'has-error': errors.has('email'), 'has-success' : fields.email && fields.email.valid  }"
        >
          <float-label>
            <input
              type="email"
              name="email"
              id="email"
              class="form-control efecto"
              placeholder="Email"
              v-model="user.email"
              v-validate="'required|email'"
              ref="email"
              data-vv-as="Email"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('email')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('email') }}</div>
        </div>
        <div
          class="form-group col-md-6"
          :class="{ 'has-error': errors.has('dni'), 'has-success' : fields.dni && fields.dni.valid  }"
        >
          <float-label>
            <input
              type="text"
              name="dni"
              id="dni"
              class="form-control efecto"
              placeholder="DNI"
              ref="dni"
              data-vv-as="DNI"
              v-model="user.dni"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('dni')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('dni') }}</div>
        </div>
        <div v-if="0"
          class="form-group col-md-6"
          :class="{ 'has-error': errors.has('email_confirm'), 'has-success' : fields.email_confirm && fields.email_confirm.valid  }"
        >
          <float-label>
            <input
              type="email"
              name="email_confirm"
              id="email_confirm"
              class="form-control efecto"
              placeholder="Verificar email"
              v-validate="'email|confirmed:email'"
              ref="confirmed"
              data-vv-as="Verificar email"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('email_confirm')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('email_confirm') }}</div>
        </div>
      </div>
      <div class="row">
        <div
          class="form-group col-md-4"
          :class="{ 'has-error': errors.has('cp'), 'has-success' : fields.cp && fields.cp.valid  }"
        >
          <float-label>
            <input
              type="text"
              name="cp"
              id="cp"
              class="form-control efecto"
              placeholder="Código Postal"
              ref="cp"
              data-vv-as="CP"
              v-model="user.cp"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('cp')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('cp') }}</div>
          <p><a href="https://www.correoargentino.com.ar/formularios/cpa" target="_blank" style="display: block; margin-top: 4px;">Averiguá tu CP</a></p>
        </div>
        <div
          class="form-group col-md-4"
          :class="{ 'has-error': errors.has('barrio'), 'has-success' : fields.barrio && fields.barrio.valid  }"
        >
          <float-label>
            <input
              type="text"
              name="barrio"
              id="barrio"
              class="form-control efecto"
              placeholder="Barrio"
              ref="barrio"
              data-vv-as="Barrio"
              v-model="user.barrio"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('barrio')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('barrio') }}</div>
        </div>
        <div class="form-group col-md-4" :class="{ 'has-error': errors.has('provincia'), 'has-success' : fields.provincia && fields.provincia.valid  }">
          <float-label label="Provincia">
            <select name="provincia" class="form-control efecto no-appearance" placeholder="Provincia" v-model="user.provincia">
              <option selected value>Provincia</option>
              <option v-for="provincia in provincias" :key="provincia" :value="provincia">{{provincia}}</option>
            </select>
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('provincia')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('provincia') }}</div>
        </div>
      </div>
      <div class="row" v-if="0">
        <div
          class="form-group col-md-4"
          :class="{ 'has-error': errors.has('telefono'), 'has-success' : fields.telefono && fields.telefono.valid  }"
        >
          <float-label>
            <input
              type="text"
              name="telefono"
              id="telefono"
              class="form-control efecto"
              placeholder="Teléfono"
              ref="telefono"
              data-vv-as="telefono"
              v-model="user.telefono"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('telefono')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('telefono') }}</div>
        </div>
        <div
          class="form-group col-md-4"
          :class="{ 'has-error': errors.has('direccion'), 'has-success' : fields.direccion && fields.direccion.valid  }"
        >
          <float-label>
            <input
              type="text"
              name="direccion"
              id="direccion"
              class="form-control efecto"
              placeholder="Dirección"
              ref="direccion"
              data-vv-as="direccion"
              v-model="user.direccion"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('direccion')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('direccion') }}</div>
        </div>
        <div class="form-group col-md-4" :class="{ 'has-error': errors.has('concesionario'), 'has-success' : fields.concesionario && fields.concesionario.valid  }">
          <float-label label="Concesionario">
            <select name="concesionaria_id" class="form-control efecto no-appearance" placeholder="Concesionario" v-model="user.concesionario">
              <option selected value>Concesionario</option>
              <option v-if="Object.keys(select_concesionarias).length" v-for="concesionaria in select_concesionarias" :key="concesionaria.id" :value="concesionaria">{{ concesionaria.nombre }}</option>
              <option v-else>Elegir provincia primero</option>
            </select>
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('concesionario')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('concesionario') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12" v-if="0">
          <p id="legal">El titular de los datos personales tiene la facultad de ejercer el derecho de acceso a los mismos en forma gratuita a intervalos no inferiores a seis meses, salvo que se acredite un interés legítimo al efecto conforme lo establecido en el artículo 14, inciso 3 de la Ley Nº 25.326. La DIRECCION NACIONAL DE PROTECCION DE DATOS PERSONALES, Órgano de Control de la Ley Nº 25.326, tiene la atribución de atender las denuncias y reclamos que se interpongan con relación al incumplimiento de las normas sobre protección de datos personales.</p>
        </div>

        <div class="col-xs-12" v-if="0">
          <div class="checkbox">
            <label>
              <input
                type="checkbox"
                id="tyc"
                name="tyc"
                v-validate="'required'"
                data-vv-as="Políticas de uso"
              > <span class="checkbox-custom"></span>He leído las Políticas de uso
            </label>
            <div
              v-if="errors.has('tyc')"
              class="animated headShake bg-danger text-danger"
            >{{ errors.first('tyc') }}</div>
          </div>
        </div>

        <div class="col-xs-12">
          <button type="submit" class="btn btn-default btn-primary" :disabled="cargando || errors.any()"><span v-text="cargando ? 'Enviando' : 'Enviar'"></span></button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";
import FloatLabel from "vue-float-label/components/FloatLabel";

export default {
  name: "Form",
  components: {
    FloatLabel
  },
  props: ["concesionarias"],
  data() {
    return {
      cargando: false,
      user: {
        nombre: "",
        apellido: "",
        email: "",
        direccion: "",
        barrio: "",
        cp: "",
        provincia: "",
        telefono: "",
        concesionario: ""
      },
      select_concesionarias: [],
      submitted: false,
      API_URL:
        window.location.hostname === "localhost"
          ? "https://d6-precios.vwcontenidos.com.ar/api/tarek"
          : "https://d6-precios.vwcontenidos.com.ar/api/tarek"
    };
  },
  watch: {
    "user.provincia": function(val) {
      if (val !== "") {
        this.select_concesionarias = this.concesionarias[val];
      }
    }
  },
  computed: {
    provincias: function() {
      return Object.keys(this.concesionarias).sort((a, b) =>
        a.localeCompare(b)
      );
    }
  },
  methods: {
    dispararEventos() {
      window.gtag("event", "conversion", {
        send_to: "AW-1050865192/30USCOf7hWQQqNyL9QM"
      });
      window.gtag("event", "conversion", {
        send_to: "DC-6703934/invmedia/taos_0+standard"
      });
      window.fbq("track", "Taos_FormComplete_Interest");
    },
    handleSubmit() {
      this.cargando = true;
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          let form_data = new FormData();
          let item = this.user;

          for (let key in item) {
            if (key == "concesionario" && item[key] != "") {
              form_data.append("concesionario", item[key].nombre);
            } else {
              form_data.append(key, item[key]);
            }
          }

          (window.smartSignals2 = window.smartSignals2 || []).push({
            event: "FormSubmissionTaos",
            payload: {
              leadInformation: {
                version: "1.0",
                leadType: "3",
                formName: "ContactRequestTaosForm",
                productName: "Taos"
              }
            }
          });
          axios
            .post(this.API_URL, form_data, {
              headers: {
                "Content-type": "application/x-www-form-urlencoded"
              }
            })
            .then(res => {
              this.cargando = false;
              if (res.status === 200) {
                this.dispararEventos();
                swal({
                  type: "success",
                  text: res.data,
                  confirmButtonText: "Volver",
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  onAfterClose: function() {
                    window.location = "https://www.volkswagen.com.ar/es.html";
                  }
                });
              } else {
                swal({
                  type: "error",
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  text:
                    "Ocurrió un error, por favor intente nuevamente más tarde."
                });
              }
            })
            .catch(() => {
              swal({
                type: "error",
                allowEscapeKey: false,
                allowOutsideClick: false,
                text:
                  "Ocurrió un error, por favor intente nuevamente más tarde."
              });
            });
        } else {
          this.cargando = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  transition: all 0.3s ease;
}

.text-danger {
  padding: 0.5em;
  border-radius: 4px;
}

textarea {
  min-width: 100%;
  max-width: 100%;
}

form {
  padding-top: 1.1em;
  & > .row.margin {
    margin-bottom: 6.7em;
  }
  & > .row:not(.margin) {
    margin-bottom: 0.8em;
  }
  h3 {
    font-size: 2.3em;
    font-family: "vw-head", Arial, Helvetica, sans-serif;
    font-weight: 400;
    letter-spacing: -0.04em;
    margin-bottom: 1.55em;
  }
  input,
  select,
  textarea {
    color: #001e50;
    border: none;
    border-bottom: 1px solid #9b9b9b;
    box-shadow: none;
    border-radius: 0;
    font-size: 1.2em;
    padding: 0;
    letter-spacing: -0.035em;
    &:hover,
    &:focus {
      box-shadow: none;
    }
    &:focus {
      outline: none;
      border-color: #9b9b9b;
    }
    &.efecto ~ .focus-border {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 1px;
      background-color: #001e50;
      transition: 0.4s;
    }
    &.efecto:focus ~ .focus-border {
      width: 100%;
      transition: 0.4s;
      left: 0;
    }
  }
  select {
    -webkit-appearance: none;
    appearance: none;
  }
  textarea {
    resize: none;
    margin-top: 0.3em;
    height: 1.6em;
  }
  .separador,
  .separador2 {
    display: block;
    height: 1.4em;
  }
  .separador2 {
    height: 7em;
  }
  #legal {
    margin-top: 6.7em;
    font-size: 1.4em;
    line-height: 1.3em;
    letter-spacing: -0.022em;
    font-weight: 200;
  }
  .checkbox {
    color: #001e50;
    font-size: 1.4em;
    margin-top: 2.1em;
    @media (max-width: 669px) {
      font-size: 1.8em;
    }
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }
    label {
      padding-left: 2em;
      vertical-align: text-bottom;
      line-height: 0.6em;
      letter-spacing: -0.007em;
      @media (max-width: 1441px) {
        line-height: 1.4em;
      }
      @media (max-width: 669px) {
        line-height: 0.3em;
      }
    }
    .checkbox-custom {
      position: absolute;
      top: 0px;
      left: 0px;
      height: 24px;
      width: 24px;
      background-color: transparent;
      transition: all 0.3s ease-out;
      -webkit-transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
      -ms-transition: all 0.3s ease-out;
      -o-transition: all 0.3s ease-out;
      border: 2px solid #001e50;
      border-radius: 0;
    }
    input:checked ~ .checkbox-custom {
      background-color: #001e50;
      -webkit-transform: rotate(0deg) scale(1);
      -ms-transform: rotate(0deg) scale(1);
      transform: rotate(0deg) scale(1);
      opacity: 1;
      border: 2px solid #001e50;
    }
    .checkbox-custom::after {
      position: absolute;
      content: "";
      left: 12px;
      top: 12px;
      height: 0px;
      width: 0px;
      border: solid white;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(0deg) scale(0);
      -ms-transform: rotate(0deg) scale(0);
      transform: rotate(0deg) scale(0);
      opacity: 1;
      transition: all 0.3s ease-out;
      -webkit-transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
      -ms-transition: all 0.3s ease-out;
      -o-transition: all 0.3s ease-out;
    }
    input:checked ~ .checkbox-custom::after {
      -webkit-transform: rotate(45deg) scale(1);
      -ms-transform: rotate(45deg) scale(1);
      transform: rotate(45deg) scale(1);
      opacity: 1;
      left: 8px;
      top: 3px;
      width: 6px;
      height: 12px;
      border: solid white;
      border-width: 0 2px 2px 0;
      background-color: transparent;
      border-radius: 0;
    }
  }
  .btn.btn-primary {
    border-radius: 22px;
    margin: 7em 0;
    font-size: 1.2em;
    padding: 0.4em 2.8em 0.6em;
    letter-spacing: -0.04em;
    color: #fff;
    background: #001e50;
    border: 1px solid #fff;
    &:focus,
    &:active {
      box-shadow: none;
      outline: none;
    }
    @media (max-width: 669px) {
      display: block;
      width: 100%;
      font-size: 1.4em;
      padding: 0.6em;
      margin: 2em 0;
    }
  }
  .relative {
    position: relative;
  }
  .has-success .form-control,
  .has-success .form-control:focus,
  .has-error .form-control,
  .has-error .form-control:focus {
    box-shadow: none;
    border-color: #9b9b9b;
  }

  .text-danger {
    background: white;
    color: #dd2c00;
    padding: 2px;
  }
}
</style>
